import {
  type CurrenciesListListData,
  type Dropdown,
  type PaginatedDropdownList,
  type ProductCategoryReadable,
  type ProductsCategoriesListListData,
  type ProductsUnitsOfMeasureListListData,
  currenciesListListInfiniteOptions,
  productsCategoriesListListInfiniteOptions,
  productsUnitsOfMeasureListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { useDefaultCurrency } from '@crm/hooks/useDefaultCurrency'
import { TipTapEditor } from '@shared/components/TipTapEditor'
import { Col, Form, Input, InputNumber, Radio, Row, Tag, theme } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

export const FormNomenclatureProductsCatalog = () => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  const form = Form.useFormInstance()
  const { defaultCurrency } = useDefaultCurrency()
  const { token } = theme.useToken()

  useEffect(() => {
    if (!form) return
    const current = form.getFieldValue('currency')

    if (!current && defaultCurrency) {
      form.setFieldsValue({
        currency: defaultCurrency
      })
    }
  }, [defaultCurrency, form])

  return (
    <Row gutter={16}>
      <Col xs={24} md={12}>
        <Form.Item
          name="name"
          label={t('nomenclature.name')}
          rules={[{ required: true }]}
        >
          <Input placeholder={t('nomenclature.name')} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name="sku"
          label={t('nomenclature.sku')}
          rules={[{ required: true }]}
        >
          <Input placeholder={t('nomenclature.sku')} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name="category"
          label={t('nomenclature.category')}
          rules={[{ required: true }]}
        >
          <InfiniteSelect<
            ProductsCategoriesListListData,
            PaginatedDropdownList,
            ProductCategoryReadable
          >
            popupMatchSelectWidth
            placeholder={t('main.select')}
            getQueryFunction={productsCategoriesListListInfiniteOptions}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item
          name="is_active"
          label={t('nomenclature.status')}
          initialValue={true}
        >
          <Radio.Group>
            <Radio value={true}>
              <Tag color={token.green5}>{t('nomenclature.active')}</Tag>
            </Radio>
            <Radio value={false}>
              <Tag color={token.red5} title={t('nomenclature.inactive')}>
                {t('nomenclature.inactive')}
              </Tag>
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          name="uom"
          label={t('nomenclature.units_measure')}
          rules={[{ required: true }]}
        >
          <InfiniteSelect<
            ProductsUnitsOfMeasureListListData,
            PaginatedDropdownList,
            Dropdown
          >
            popupMatchSelectWidth
            placeholder={t('main.select')}
            getQueryFunction={productsUnitsOfMeasureListListInfiniteOptions}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          name="price"
          label={t('nomenclature.price')}
          rules={[{ required: true }]}
        >
          <InputNumber
            className="w-full"
            min={0}
            placeholder={t('nomenclature.price')}
          />
        </Form.Item>
      </Col>

      <Col xs={24} md={8}>
        <Form.Item
          name="currency"
          label={t('contracts.currency')}
          rules={[{ required: true }]}
        >
          <InfiniteSelect<
            CurrenciesListListData,
            PaginatedDropdownList,
            Dropdown
          >
            popupMatchSelectWidth
            placeholder={t('main.select')}
            getQueryFunction={currenciesListListInfiniteOptions}
          />
        </Form.Item>
      </Col>

      <Col xs={24}>
        <Form.Item name="description" label={t('nomenclature.description')}>
          <TipTapEditor className={styles.editor} />
        </Form.Item>
      </Col>
    </Row>
  )
}
